export const FixedTab = {
  CapManagement: 'CAP',
  CapManagementNew: 'CAP_NEW',
  Overview: 'OVERVIEW',
  Progress: 'PROGRESS',
  Reports: 'REPORTS',
  SaqManagement: 'SAQ_MANAGEMENT',
  ManageSaqUser: 'MANAGE_SAQ_USER',
  MobileData: 'MOBILE_DATA',
  Survey: 'SURVEY',
  SurveyDashboard: 'SURVEY_DASHBOARD',
  SurveyFalsification: 'SURVEY_FALSIFICATION',
};

export const DEFAULT_TAB_KEY = FixedTab.Overview;
export const NEW_SAQ_DEFAULT_TAB_KEY = FixedTab.ManageSaqUser;

export const JobStakeholderRole = {
  CapManager: 'CAP_Manager',
  CapSupportStaff: 'CAP_Support_Staff',
};

export const JobStakeholderRoleTranslation = {
  [JobStakeholderRole.CapManager]: 'CAP_MANAGER',
  [JobStakeholderRole.CapSupportStaff]: 'CAP_SUPPORT_STAFF',
};

export const JobStakeholdersPopupType = {
  Add: 'ADD',
  Edit: 'EDIT',
};

/**
 * @type {{Closed: string, NotRequired: string, Open: string}}
 * new types to match CAP job finding statuses
 * which is now different from CAP Action statuses(FindingStatus)
 */
export const FindingSectionStatus = {
  Open: 'Open',
  Closed: 'Closed',
  NotRequired: 'not_required',
};

export const CapAllowedToFinishStatuses = ['cap_not_accepted', 'cap_accepted'];

export const ServiceTypes = {
  CAP: 'cap',
  SAQ: 'saq',
  UNVERIFIED_SAQ: 'unverified_saq',
  HIDDEN: 'hidden',
};
